const { CENTIMETERS_PER_METER } = require('../utilities/convertConstants.js');

const calculateBMI = (height, weight, weight_unknown) => {
  if (weight_unknown === 'yes') {
    return null;
  }

  const heightInMeters = parseFloat(height) / CENTIMETERS_PER_METER;
  const weightInKg = parseFloat(weight);

  if (heightInMeters <= 0 || weightInKg <= 0) {
    return null;
  }

  if (isNaN(heightInMeters) || isNaN(weightInKg)) {
    return null;
  }

  const bmiFloat = weightInKg / (heightInMeters * heightInMeters);
  const roundedBMI = bmiFloat.toFixed(1);
  const bmi = parseFloat(roundedBMI);
  return bmi;
};

module.exports = calculateBMI;
